import { useTranslation } from 'react-i18next';

type Props = {
  amount: string;
  token: string;
  chainId: number;
  txHash: string;
  creditedAt: string | null;
  isWorldApp: boolean;
  onClose: () => void;
};

function formatIdentifier(value: string): string {
  if (value.length <= 26) return value;
  return `${value.slice(0, 14)}…${value.slice(-10)}`;
}

function formatTimestamp(value: string | null): string | null {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
}

function IdentifierRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="transfer-success-detail">
      <dt>{label}</dt>
      <dd title={value}><code>{formatIdentifier(value)}</code></dd>
    </div>
  );
}

export default function BbgDepositSuccessModal({
  amount,
  token,
  chainId,
  txHash,
  creditedAt,
  isWorldApp,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const formattedCreditedAt = formatTimestamp(creditedAt);

  return (
    <div className="modal-backdrop" role="presentation">
      <section className="transfer-success-modal" role="dialog" aria-modal="true" aria-labelledby="bbg-deposit-success-title">
        <div className="transfer-success-icon" aria-hidden="true">✓</div>
        <p className="eyebrow">WORLD CHAIN · BBG</p>
        <h2 id="bbg-deposit-success-title">{t('transfer.successTitle')}</h2>
        <p className="transfer-success-copy">{t('transfer.successDescription')}</p>

        <dl className="transfer-success-details">
          <div className="transfer-success-detail">
            <dt>{t('transfer.successAmount')}</dt>
            <dd>{amount} {token}</dd>
          </div>
          <div className="transfer-success-detail">
            <dt>{t('transfer.successChainId')}</dt>
            <dd>{chainId}</dd>
          </div>
          <IdentifierRow label={t('transfer.successTxHash')} value={txHash} />
          {formattedCreditedAt && (
            <div className="transfer-success-detail">
              <dt>{t('transfer.successCreditedAt')}</dt>
              <dd>{formattedCreditedAt}</dd>
            </div>
          )}
        </dl>

        <a
          className="send-token-hash"
          href={`https://worldscan.org/tx/${txHash}`}
          target={isWorldApp ? undefined : '_blank'}
          rel={isWorldApp ? undefined : 'noreferrer'}
        >
          {t('transfer.viewOnWorldscan')}
        </a>

        <button className="primary-button" type="button" onClick={onClose}>
          {t('transfer.done')}
        </button>
      </section>
    </div>
  );
}
